<template>
  <!-- <div class="row wrapper border-bottom white-bg page-heading"> -->
    <!-- <div class="col-lg-10">
      <h2>{{ $t("navigations.subject schedule") }}</h2>
    </div>
    <div class="col-lg-2">
      <span class="tooltip-wrapper pointer" style="float:right">
        <i class="fa fa-times close cursor-pointer" @click="$router.go(-1)"></i>
        <span class="custom-tooltip closetooltipposition">Close</span>
      </span>
    </div> -->
  <!-- </div> -->

  <div class="ibox mb-0">

    <!-- TITLE -->
    <div class="ibox-title style_2">
      <h5 class="mb-0">Subject Schedule</h5>
    </div>

    <!-- CONTENT -->
    <div class="ibox-content horizondalscroll fixedheight">
            <ul class="tree pl-1">
              <li>
                <input type="checkbox" :id="subjectId" :ref="subjectId" @change="getVisits(subjectId, 0)" />
                <label :for="subjectId" class="tree_label">{{
                  subjectname
                }}</label>
                <ul v-if="hasadditionalforms[subjectId]">
                  <li>
                    <input type="checkbox" :id="subjectId + 'additionalforms'"
                      @change="getAdditionalForms(subjectId)" />
                    <label :for="subjectId + 'additionalforms'" class="tree_label">
                      Additional forms
                    </label>
                  </li>
                  <!-- Grouped Forms with Collapsible Folders -->
                  <ul v-if="groupedAdditionalForms[subjectId] && additionalformchecked[subjectId]">
                    <li v-for="(group, templateId) in groupedAdditionalForms[subjectId]" :key="templateId"
                      class="group-folder-item">
                      <!-- Collapsible Group Folder with Checkbox -->
                      <input type="checkbox" :id="subjectId + templateId + 'group'"
                        :checked="expandedAdditionalGroups[subjectId] && expandedAdditionalGroups[subjectId][templateId]"
                        @change="toggleAdditionalGroup(subjectId, templateId)" />
                      <label :for="subjectId + templateId + 'group'" class="tree_label tree_folder_label">
                        {{ group.templateName }} ({{ group.forms.length }})
                      </label>

                      <!-- Individual Forms - Shown only when group is expanded -->
                      <ul v-if="expandedAdditionalGroups[subjectId] && expandedAdditionalGroups[subjectId][templateId]"
                        class="group-forms-list">
                        <li v-for="form in group.forms" :key="form.formId">
                          <input type="checkbox" :id="form.formId + subjectId"
                            @click.prevent="gotoform(form)" />
                          <label class="tree_label" :for="form.formId + subjectId" @click.stop>
                            <!-- {{
                              form.formStatus === "Completed"
                                ? form.templateName +
                                " - " +
                                (form.visitCompletedDate
                                  ? filter(form.visitCompletedDate) + "-"
                                  : "")
                                : form.templateName
                            }} -->
                            {{ form.templateName }} ({{ form.version }}) - {{ form.languageCode.toUpperCase() }} 



                            <span class="badge custom-form-tooltip-wrapper ml-2"
                              :style="`background-color: ${form.formStatusHex}; color: black;`">
                              {{ form.formStatus }}</span>

                          </label>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </ul>
                <ul v-if="visitTreeObj?.[subjectId]?.length">
                  <template v-for="(node, nodeIndex) in (visitTreeObj[subjectId] || [])"
                    :key="`${node?.type || 'node'}-${node?.cycleId || node?.studyPhaseId || node?.displayText || 'unknown'}-${nodeIndex}`">
                    <li v-if="node && node.type === 'visit'">
                      <input v-if="node.visit.visitNo != '' && node.visit.visitNo != null" type="checkbox"
                        :id="node.visit.sheduleId + subjectId" @change="
                          getactivities(
                            subjectId,
                            node.visit.visitNo,
                            node.visit.visitName,
                            node.visit.__visitIndex,
                            node.visit.sheduleId,
                            node.visit.patientNo
                          )
                          " />
                      <div class="tree-row">
                        <label v-if="node.visit.visitNo != '' && node.visit.visitNo != null"
                          :for="node.visit.sheduleId + subjectId" class="tree_label">
                          <b>{{ node.visit.visitNo }} - {{ node.visit.visitName }}</b> - ( {{ setdate(node.visit) }} )
                          <span class="badge custom-tooltip-wrapper"
                            @mouseenter="showPopover(`visitStatus-${sIndex}-${0}-${node.visit.__visitIndex}`)"
                            @mouseleave="hidePopover(`visitStatus-${sIndex}-${0}-${node.visit.__visitIndex}`)"
                            :popovertarget="`visitStatus-${sIndex}-${0}-${node.visit.__visitIndex}`"
                            :style="`background-color: ${node.visit.visitStatusHex}; color: black; anchor-name:--visitStatus-${sIndex}-${0}-${node.visit.__visitIndex};`">
                            {{ node.visit.visitStatus }}</span><span class="custom-tooltip-text"
                            v-if="node.visit.visitStatusDescription" popover
                            :id="`visitStatus-${sIndex}-${0}-${node.visit.__visitIndex}`"
                            :style="`position-anchor:--visitStatus-${sIndex}-${0}-${node.visit.__visitIndex};`">{{
                              node.visit.visitStatusDescription }}</span>
                        </label>
                        <span class="tree-actions position-relative cursor-pointer px-2"
                          @click.prevent="toggleSidePopup(sIndex, 0, node.visit.__visitIndex)"
                          v-on:clickout="closeSidePopup(sIndex, 0, node.visit.__visitIndex)">
                          <i class="fa fa-ellipsis-v"></i>
                        </span>
                      </div>
                      <div class="plan-side-popup" v-if="
                        showSidePopup[sIndex] &&
                        showSidePopup[sIndex][0] &&
                        showSidePopup[sIndex][0][node.visit.__visitIndex]
                      ">
                        <!-- Plan Last Next Visit Will be empty-->
                        <div
                          v-if="hasNextSortedVisit(subjectId, node.visit)"
                          @click.prevent="openPlanNextVisitModal(subjectId, node.visit)">
                          Plan Next Visit
                        </div>
                        <div @click.prevent="openManageVisitPopup(node.visit)">
                          Change Visit Date
                        </div>
                        <div @click.prevent="openManageVisitPopupNew(node.visit)">
                          Manage Visit
                        </div>
                         <div @click.prevent="openUnscheduledVisitModal(node.visit, pIndex)">
                                  Add Unscheduled Visit
                                  </div>
                        <div @click.prevent="openchangeplanneddatePopup(node.visit)">
                           Change Planned Date
                          </div>  
                        <div v-if="node.visit.visitStatus != 'Completed'" @click.prevent="
                          openChangeStatusmodal(
                            node.visit.studyId,
                            node.visit.visitNo,
                            subjectId,
                            node.visit.visitStatus,
                            0,
                            'Visit'
                          )
                          ">
                          {{ $t('navigations.change status') }}
                        </div>
                      </div>
                      <ul>
                        <li v-if="observationValue[node.visit.visitNo + subjectId] == true">
                          <input type="checkbox">
                          <label
                            @click.prevent="toggleObservationFolder(node.visit.siteCode, node.visit.patientNo, node.visit.visitName, node.visit.visitNo, subjectId)"
                            class="tree_label">{{ $t("navigations.observations") }}</label>

                          <template v-if="categoryFlags[node.visit.visitNo + subjectId]">
                            <div v-for="docType in categoryFlags[node.visit.visitNo + subjectId]" :key="docType.id"
                              class="tree-node mb-2">
                              <div @click.prevent="docType.flag = !docType.flag">
                                <span class="cursor-pointer">
                                  <i class="fa fa-file-code-o text-primary me-2"></i>
                                  {{ docType.category }}
                                </span>
                              </div>
                              <div class="row" v-if="docType.flag == true">
                                <div class="d-flex pt-2 pl-4 cursor-pointer" v-for="(value, index) in docType.code"
                                  :key="index"
                                  @click.prevent="selectDocument(node.visit.siteCode, subjectname, docType.document[index], node.visit.visitName, subjectId, node.visit.siteId)">
                                  <span class="mr-1">{{ value }}</span>
                                  <span v-if="docType.effectiveDateTime[index]">
                                    ({{ filterTimeFormat(docType.effectiveDateTime[index]) }})
                                  </span>
                                </div>
                              </div>
                            </div>
                          </template>
                        </li>
                      </ul>
                      <template
                        v-if="(activityobject?.[`${node.visit.visitNo}_${subjectId}`]?.[node.visit.__visitIndex] || []).length">
                        <ul
                          v-for="(singleactivity, activityindex) in (activityobject?.[`${node.visit.visitNo}_${subjectId}`]?.[node.visit.__visitIndex] || [])"
                          :key="singleactivity.activityId">
                          <li>
                            <input v-if="singleactivity.activityId"
                              :id="activityInputId(singleactivity, subjectId, node.visit)" type="checkbox" @change="
                                getFormsByVisit(subjectId,
                                  node.visit.visitNo,
                                  node.visit.visitName,
                                  node.visit.__visitIndex,
                                  node.visit.sheduleId,
                                  activityindex,
                                  singleactivity.activityId,
                                  singleactivity.activityOrder
                                )
                                " />
                            <label class="tree_label" :for="activityInputId(singleactivity, subjectId, node.visit)"
                              @click.stop>

                              <div>

                                <span>

                                  {{ singleactivity.activityName }}
                                  <span class="badge custom-form-tooltip-wrapper"
                                    :style="`background-color: ${singleactivity.statusHex}; color: black;`">
                                    {{ singleactivity.status }}</span>
                                </span>
                                <button v-if="singleactivity.formStatus !== 'Completed'"
                                  :popovertarget="popoverId(singleactivity.activityId, sIndex, 0, node.visit.__visitIndex)"
                                  :anchor="popoverId('visitForms', sIndex, 0, node.visit.__visitIndex)"
                                  class="visit-ellipsis-btn py-0 px-3" @click.stop>
                                  <i class="fa fa-ellipsis-v"></i>
                                </button>
                                <div
                                  :id="popoverId(singleactivity.activityId, sIndex, 0, node.visit.__visitIndex)"
                                  popover class="visit-popup-menu">
                                  <button @click.prevent.stop="
                                    openChangeStatusmodalforactivity(
                                      singleactivity.actScheduleId,
                                      singleactivity.status,
                                      subjectId,
                                      node.visit.visitNo,
                                      node.visit.visitName,
                                      node.visit.__visitIndex,
                                      node.visit.sheduleId,
                                      popoverId(singleactivity.activityId, sIndex, 0, node.visit.__visitIndex),
                                    )
                                    " class="popup-menu-block text-left w-100">
                                    {{ $t('navigations.change status') }}
                                  </button>
                                  <button @click.prevent="
                                    openModal(
                                      {
                                        visitNo: node.visit.visitNo,
                                        visitName: node.visit.visitName,
                                        sheduleId: node.visit.sheduleId,
                                        studyId: node.visit.studyId,
                                        visitId: singleactivity.visitId,
                                        actScheduleId: singleactivity.actScheduleId,
                                        subjectId: singleactivity.subjectId,
                                        activityId: singleactivity.activityId,
                                        activityName: singleactivity.activityName
                                      },
                                      subjectname,
                                      node.visit.siteCode,
                                      singleactivity.status,
                                      popoverId(singleactivity.activityId, sIndex, 0, node.visit.__visitIndex)
                                    )
                                    " class="popup-menu-block text-left w-100">
                                    {{ $t('navigations.new form') }}
                                  </button>
                                </div>
                              </div>
                            </label>
                            <template v-if="visitFormObj[node.visit.visitNo + subjectId]">
                              <ul>
                                <li v-for="singlevisit in visitFormObj[
                                  node.visit.visitNo + subjectId
                                ][activityindex]" :key="singlevisit.sheduleId">

                                  <input v-if="singlevisit.templateName" type="checkbox"
                                    :id="formInputId(singlevisit, 0, node.visit.__visitIndex, activityindex)"
                                    @click.prevent="
                                      gotoform(singlevisit)
                                      " />
                                  <label class="tree_form"
                                    :for="formInputId(singlevisit, 0, node.visit.__visitIndex, activityindex)"
                                    @click.stop>

                                    <div class="d-flex">

                                      <div class="d-flex align-items-center">
                                        <p class="mb-0" style="max-width: 28ch;">
                                          {{ singlevisit.templateName }} ({{ singlevisit.version }}) - {{ singlevisit.languageCode.toUpperCase() }} 

                                        </p>
                                        <span class="badge custom-form-tooltip-wrapper ml-2"
                                          @mouseenter="showPopover(`formStatus-${singlevisit.sheduleId}-${0}-${node.visit.__visitIndex}`)"
                                          @mouseleave="hidePopover(`formStatus-${singlevisit.sheduleId}-${0}-${node.visit.__visitIndex}`)"
                                          :popovertarget="`formStatus-${singlevisit.sheduleId}-${0}-${node.visit.__visitIndex}`"
                                          :style="`background-color: ${singlevisit.formStatusHex}; color: black; anchor-name:--formStatus-${singlevisit.sheduleId}-${0}-${node.visit.__visitIndex};`">
                                          {{ singlevisit.formStatus }}</span>
                                        <span v-if="singlevisit.formStatusDescription" popover
                                          class="custom-form-tooltip-text"
                                          :id="`formStatus-${singlevisit.sheduleId}-${0}-${node.visit.__visitIndex}`"
                                          :style="`position-anchor:--formStatus-${singlevisit.sheduleId}-${0}-${node.visit.__visitIndex};`">
                                          {{ singlevisit.formStatusDescription }}</span>
                                      </div>


                                      <button
                                        :popovertarget="popoverId(singlevisit.sheduleId, sIndex, 0, node.visit.__visitIndex)"
                                        :anchor="popoverId('visitForms', sIndex, 0, node.visit.__visitIndex)"
                                        class="visit-ellipsis-btn py-0 px-3" @click.stop>
                                        <i class="fa fa-ellipsis-v"></i>
                                      </button>
                                      <div
                                        :id="popoverId(singlevisit.sheduleId, sIndex, 0, node.visit.__visitIndex)"
                                        popover class="visit-popup-menu">
                                        <button v-if="singlevisit.formStatus !== 'Completed'" @click.prevent.stop="
                                          openChangeStatusmodal(
                                            node.visit.studyId,
                                            node.visit.visitNo,
                                            subjectId,
                                            node.visit.visitStatus,
                                            node.visit.__visitIndex,
                                            'Form',
                                            popoverId(singlevisit.sheduleId, sIndex, 0, node.visit.__visitIndex),
                                            node.visit.visitName,
                                            singlevisit.formStatus,
                                            singlevisit.formId,
                                            singlevisit.sheduleId
                                          )
                                          " class="popup-menu-block text-left w-100">
                                          {{ $t('navigations.change status') }}
                                        </button>
                                        <button
                                          v-if="roleprivileges.includes('Subject Schedule Change eCRF') && singlevisit.formStatus !== 'Completed'"
                                          @click.prevent="
                                            ChangeTemplatePopup(
                                              node.visit.studyId,
                                              node.visit.visitNo,
                                              subjectId,
                                              node.visit.visitStatus,
                                              node.visit.__visitIndex,
                                              'Form',
                                              popoverId(singlevisit.sheduleId, sIndex, 0, node.visit.__visitIndex),
                                              node.visit.visitName,
                                              singlevisit.formStatus,
                                              singlevisit.sheduleId,
                                              singlevisit.templateId
                                            )
                                            " class="popup-menu-block text-left w-100">
                                          {{ $t('navigations.change ecrf') }}
                                        </button>
                                        <button
                                          v-if="singlevisit.formStatus == 'Completed' && singlevisit.sdvAssigned == false && singlevisit.isSdv == true"
                                          @click.prevent.stop="
                                          assignSdv(
                                            singlevisit.formId,
                                            singlevisit.templateId,
                                            popoverId(singlevisit.sheduleId, sIndex, 0, node.visit.__visitIndex)
                                          )
                                          " class="popup-menu-block text-left w-100">
                                          {{ $t('navigations.assign sdv') }}
                                        </button>
                                      </div>
                                    </div>
                                  </label>
                                </li>
                              </ul>
                            </template>
                          </li>
                        </ul>
                      </template>
                    </li>
                    <li v-if="node && (node.type === 'cycle' || node.type === 'studyPhase')">
                    <input type="checkbox" :id="`${node.type}-${subjectId}-${nodeIndex}`" />
                    <div class="tree-row">
                      <label class="tree_label" :for="`${node.type}-${subjectId}-${nodeIndex}`">
                        <b>{{ node.displayText }}</b>
                      </label>
                      <span v-if="node.type === 'cycle'" class="tree-actions position-relative cursor-pointer px-2"
                        @click.prevent="toggleCycleSidePopup(nodeIndex)"
                        v-on:clickout="closeCycleSidePopup(nodeIndex)">
                        <i class="fa fa-ellipsis-v"></i>
                      </span>
                    </div>
                    <div class="plan-side-popup" v-if="node.type === 'cycle' && showCycleSidePopup[0] && showCycleSidePopup[0][nodeIndex]">
                      <div @click.prevent="openScheduleCyclePopup(node.cycleId, subjectId)">
                        Repeat Cycle
                      </div>
                      <div @click.prevent="openManageCyclePopup(node.cycleId, subjectId, node.occurence)">
                        Manage Cycle
                      </div>
                      <div @click.prevent="openCycleStatusUpdatePopup(node.cycleId, node.occurence, subjectId)">
                        Update Cycle Status
                      </div>
                    </div>
                    <!-- ================= VISITS INSIDE FOLDER ================= -->
                    <ul>
                      <li
                        v-for="(visit, visitIndex) in node.visits"
                        :key="
                          visit && visit.type === 'cycle'
                            ? `cycle-${subjectId}-${getNestedNodeIndex(nodeIndex, visitIndex)}`
                            : visit.sheduleId
                        "
                      >
                        <template v-if="visit && visit.type === 'cycle'">
                          <input
                            type="checkbox"
                            :id="`cycle-${subjectId}-${getNestedNodeIndex(nodeIndex, visitIndex)}`"
                          />
                          <div class="tree-row">
                            <label class="tree_label" :for="`cycle-${subjectId}-${getNestedNodeIndex(nodeIndex, visitIndex)}`">
                              <b>{{ visit.displayText }}</b>
                            </label>
                            <span class="tree-actions position-relative cursor-pointer px-2"
                              @click.prevent="toggleCycleSidePopup(getNestedNodeIndex(nodeIndex, visitIndex))"
                              v-on:clickout="closeCycleSidePopup(getNestedNodeIndex(nodeIndex, visitIndex))">
                              <i class="fa fa-ellipsis-v"></i>
                            </span>
                          </div>
                          <div class="plan-side-popup" v-if="showCycleSidePopup[0] && showCycleSidePopup[0][getNestedNodeIndex(nodeIndex, visitIndex)]">
                            <div @click.prevent="openScheduleCyclePopup(visit.cycleId, subjectId)">
                              Repeat Cycle
                            </div>
                            <div @click.prevent="openManageCyclePopup(visit.cycleId, subjectId, visit.occurence)">
                              Manage Cycle
                            </div>
                            <div @click.prevent="openCycleStatusUpdatePopup(visit.cycleId, visit.occurence, subjectId)">
                              Update Cycle Status
                            </div>
                          </div>
                          <ul>
                            <li v-for="cycleVisit in visit.visits" :key="cycleVisit.sheduleId">
                              <input type="checkbox" :id="cycleVisit.sheduleId + subjectId" @change="
                                getactivities(
                                  subjectId,
                                  cycleVisit.visitNo,
                                  cycleVisit.visitName,
                                  cycleVisit.__visitIndex,
                                  cycleVisit.sheduleId,
                                  cycleVisit.patientNo
                                )
                                " />

                              <div class="tree-row">
                                <label :for="cycleVisit.sheduleId + subjectId" class="tree_label">
                                  <b>{{ cycleVisit.visitNo }} - {{ cycleVisit.visitName }}</b> - ( {{ setdate(cycleVisit) }} )
                                  <span class="badge custom-tooltip-wrapper"
                                    :style="`background-color: ${cycleVisit.visitStatusHex}; color: black;`">
                                    {{ cycleVisit.visitStatus }}
                                  </span>
                                </label>
                                <span class="tree-actions position-relative cursor-pointer px-2"
                                  @click.prevent="toggleSidePopup(sIndex, 0, cycleVisit.__visitIndex)"
                                  v-on:clickout="closeSidePopup(sIndex, 0, cycleVisit.__visitIndex)">
                                  <i class="fa fa-ellipsis-v"></i>
                                </span>
                              </div>

                              <div class="plan-side-popup" v-if="
                                showSidePopup[sIndex] &&
                                showSidePopup[sIndex][0] &&
                                showSidePopup[sIndex][0][cycleVisit.__visitIndex]
                              ">
                                <div
                                  v-if="hasNextSortedVisit(subjectId, cycleVisit)"
                                  @click.prevent="openPlanNextVisitModal(subjectId, cycleVisit)">
                                  {{ $t('navigations.plan next visit') }}
                                </div>
                                <div @click.prevent="openManageVisitPopup(cycleVisit)">
                                 Change Visit Date
                                </div>
                                <div @click.prevent="openManageVisitPopupNew(cycleVisit)">
                                Manage Visit
                              </div>
                               <div @click.prevent="openUnscheduledVisitModal(cycleVisit, pIndex)">
                                        Add Unscheduled Visit
                                        </div>
                                <div @click.prevent="openchangeplanneddatePopup(cycleVisit)">
                                 Change Planned Date
                                </div>
                                <div v-if="cycleVisit.visitStatus != 'Completed'" @click.prevent="
                                  openChangeStatusmodal(
                                    cycleVisit.studyId,
                                    cycleVisit.visitNo,
                                    subjectId,
                                    cycleVisit.visitStatus,
                                    cycleVisit.__visitIndex,
                                    'Visit'
                                  )
                                  ">
                                  {{ $t('navigations.change status') }}
                                </div>
                              </div>

                              <ul>
                                <li v-if="observationValue[cycleVisit.visitNo + subjectId] === true">
                                  <input type="checkbox" />
                                  <label @click.prevent="
                                    toggleObservationFolder(
                                      cycleVisit.siteCode,
                                      cycleVisit.patientNo,
                                      cycleVisit.visitName,
                                      cycleVisit.visitNo,
                                      subjectId
                                    )
                                    " class="tree_label">
                                    {{ $t("navigations.observations") }}
                                  </label>

                                  <template v-if="categoryFlags[cycleVisit.visitNo + subjectId]">
                                    <div v-for="docType in categoryFlags[cycleVisit.visitNo + subjectId]" :key="docType.id"
                                      class="tree-node mb-2">
                                      <div @click.prevent="docType.flag = !docType.flag">
                                        <span class="cursor-pointer">
                                          <i class="fa fa-file-code-o text-primary me-2"></i>
                                          {{ docType.category }}
                                        </span>
                                      </div>

                                      <div class="row" v-if="docType.flag === true">
                                        <div class="d-flex pt-2 pl-4 cursor-pointer" v-for="(value, index) in docType.code"
                                          :key="index" @click.prevent="
                                            selectDocument(
                                              cycleVisit.siteCode,
                                              subjectId,
                                              docType.document[index],
                                              cycleVisit.visitName,
                                              subjectId,
                                              cycleVisit.siteId
                                            )
                                            ">
                                          <span class="mr-1">{{ value }}</span>
                                          <span v-if="docType.effectiveDateTime[index]">
                                            ({{ filterTimeFormat(docType.effectiveDateTime[index]) }})
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </template>
                                </li>
                              </ul>

                              <template
                                v-if="(activityobject?.[`${cycleVisit.visitNo}_${subjectId}`]?.[cycleVisit.__visitIndex] || []).length">
                                <ul>
                                  <li v-for="(singleactivity, activityindex) in
                                    (activityobject?.[`${cycleVisit.visitNo}_${subjectId}`]?.[cycleVisit.__visitIndex] || [])"
                                    :key="singleactivity.activityId">
                                    <input v-if="singleactivity.activityId"
                                      :id="activityInputId(singleactivity, subjectId, cycleVisit)" type="checkbox" @change="
                                        getFormsByVisit(
                                          subjectId,
                                          cycleVisit.visitNo,
                                          cycleVisit.visitName,
                                          cycleVisit.__visitIndex,
                                          cycleVisit.sheduleId,
                                          activityindex,
                                          singleactivity.activityId,
                                          singleactivity.activityOrder
                                        )
                                        " />

                                      <label class="tree_label" :for="activityInputId(singleactivity, subjectId, cycleVisit)"
                                        @click.stop>
                                        <div>
                                          <span>
                                            {{ singleactivity.activityName }}
                                            <span class="badge custom-form-tooltip-wrapper"
                                              :style="`background-color: ${singleactivity.statusHex}; color: black;`">
                                              {{ singleactivity.status }}
                                            </span>
                                          </span>
                                          <button v-if="singleactivity.formStatus !== 'Completed'"
                                            :popovertarget="popoverId(singleactivity.activityId, sIndex, 0, cycleVisit.__visitIndex)"
                                            :anchor="popoverId('visitForms', sIndex, 0, cycleVisit.__visitIndex)"
                                            class="visit-ellipsis-btn py-0 px-3" @click.stop>
                                            <i class="fa fa-ellipsis-v"></i>
                                          </button>
                                          <div :id="popoverId(singleactivity.activityId, sIndex, 0, cycleVisit.__visitIndex)" popover
                                            class="visit-popup-menu">
                                            <button @click.prevent.stop="
                                              openChangeStatusmodalforactivity(
                                                singleactivity.actScheduleId,
                                                singleactivity.status,
                                                subjectId,
                                                cycleVisit.visitNo,
                                                cycleVisit.visitName,
                                                cycleVisit.__visitIndex,
                                                cycleVisit.sheduleId,
                                                popoverId(singleactivity.activityId, sIndex, 0, cycleVisit.__visitIndex),
                                              )
                                              " class="popup-menu-block text-left w-100">
                                              {{ $t('navigations.change status') }}
                                            </button>
                                            <button @click.prevent="
                                              openModal(
                                                {
                                                  visitNo: cycleVisit.visitNo,
                                                  visitName: cycleVisit.visitName,
                                                  sheduleId: cycleVisit.sheduleId,
                                                  studyId: cycleVisit.studyId,
                                                  visitId: singleactivity.visitId,
                                                  actScheduleId: singleactivity.actScheduleId,
                                                  subjectId: singleactivity.subjectId,
                                                  activityId: singleactivity.activityId,
                                                  activityName: singleactivity.activityName
                                                },
                                                subjectname,
                                                cycleVisit.siteCode,
                                                singleactivity.status,
                                                popoverId(singleactivity.activityId, sIndex, 0, cycleVisit.__visitIndex)
                                              )
                                              " class="popup-menu-block text-left w-100">
                                              {{ $t('navigations.new form') }}
                                            </button>
                                          </div>
                                        </div>
                                      </label>

                                    <template v-if="visitFormObj[cycleVisit.visitNo + subjectId]">
                                      <ul>
                                        <li v-for="singlevisit in visitFormObj[
                                          cycleVisit.visitNo + subjectId
                                        ][activityindex]" :key="singlevisit.sheduleId">
                                          <input v-if="singlevisit.templateName" type="checkbox"
                                            :id="formInputId(singlevisit, 0, cycleVisit.__visitIndex, activityindex)"
                                            @click.prevent="
                                              gotoform(singlevisit)
                                            " />

                                          <label class="tree_label"
                                            :for="formInputId(singlevisit, 0, cycleVisit.__visitIndex, activityindex)"
                                            @click.stop>
                                            <div class="d-flex">
                                              <div class="d-flex align-items-center">
                                                <p class="mb-0" style="max-width: 28ch;">
                                                  {{
                                                    // singlevisit.formStatus === 'Completed'
                                                    //   ? singlevisit.templateName +
                                                    //     ' - ' +
                                                    //     (singlevisit.visitCompletedDate
                                                    //       ? filter(singlevisit.visitCompletedDate) + '-'
                                                    //       : '')
                                                    //   : singlevisit.templateName
                                                    singlevisit.formStatus === 'Completed'
                                                  ? singlevisit.templateName + ' (' + singlevisit.version + ') - ' + singlevisit.languageCode?.toUpperCase() +
                                                  ' - ' +
                                                  (singlevisit.visitCompletedDate
                                                  ? filter(singlevisit.visitCompletedDate) + '-'
                                                  : '')
                                                  : singlevisit.templateName + ' (' + singlevisit.version + ') - ' + singlevisit.languageCode?.toUpperCase()
                                                  }}
                                                </p>

                                                <span class="badge custom-tooltip-wrapper"
                                                  @mouseenter="showPopover(`formStatus-${singlevisit.sheduleId}-0-${cycleVisit.__visitIndex}`)"
                                                  @mouseleave="hidePopover(`formStatus-${singlevisit.sheduleId}-0-${cycleVisit.__visitIndex}`)"
                                                  :popovertarget="`formStatus-${singlevisit.sheduleId}-0-${cycleVisit.__visitIndex}`"
                                                  :style="`background-color: ${singlevisit.formStatusHex}; color: black;`">
                                                  {{ singlevisit.formStatus }}
                                                </span>

                                                <span v-if="singlevisit.formStatusDescription" popover
                                                  class="custom-form-tooltip-text"
                                                  :id="`formStatus-${singlevisit.sheduleId}-0-${cycleVisit.__visitIndex}`">
                                                  {{ singlevisit.formStatusDescription }}
                                                </span>
                                              </div>

                                              <button
                                                :popovertarget="popoverId(singlevisit.sheduleId, sIndex, 0, cycleVisit.__visitIndex)"
                                                :anchor="popoverId('visitForms', sIndex, 0, cycleVisit.__visitIndex)"
                                                class="visit-ellipsis-btn py-0 px-3" @click.stop>
                                                <i class="fa fa-ellipsis-v"></i>
                                              </button>

                                              <div :id="popoverId(singlevisit.sheduleId, sIndex, 0, cycleVisit.__visitIndex)"
                                                popover class="visit-popup-menu">
                                                <button v-if="singlevisit.formStatus !== 'Completed'" @click.prevent.stop="
                                                  openChangeStatusmodal(
                                                    cycleVisit.studyId,
                                                    cycleVisit.visitNo,
                                                    subjectId,
                                                    cycleVisit.visitStatus,
                                                    cycleVisit.__visitIndex,
                                                    'Form',
                                                    popoverId(singlevisit.sheduleId, sIndex, 0, cycleVisit.__visitIndex),
                                                    cycleVisit.visitName,
                                                    singlevisit.formStatus,
                                                    singlevisit.formId,
                                                    singlevisit.sheduleId
                                                  )
                                                  " class="popup-menu-block text-left w-100">
                                                  {{ $t('navigations.change status') }}
                                                </button>
                                              </div>
                                            </div>
                                          </label>
                                        </li>
                                      </ul>
                                    </template>
                                  </li>
                                </ul>
                              </template>
                            </li>
                          </ul>
                        </template>
                        <template v-else>
                          <input type="checkbox" :id="visit.sheduleId + subjectId" @change="
                            getactivities(
                              subjectId,
                              visit.visitNo,
                              visit.visitName,
                              visit.__visitIndex,
                              visit.sheduleId,
                              visit.patientNo
                            )
                            " />

                          <div class="tree-row">
                            <label :for="visit.sheduleId + subjectId" class="tree_label">
                              <b>{{ visit.visitNo }} - {{ visit.visitName }}</b> - ( {{ setdate(visit) }} )
                              <span class="badge custom-tooltip-wrapper"
                                :style="`background-color: ${visit.visitStatusHex}; color: black;`">
                                {{ visit.visitStatus }}
                              </span>
                            </label>

                            <span class="tree-actions position-relative cursor-pointer px-2"
                              @click.prevent="toggleSidePopup(sIndex, 0, visit.__visitIndex)"
                              v-on:clickout="closeSidePopup(sIndex, 0, visit.__visitIndex)">
                              <i class="fa fa-ellipsis-v"></i>
                            </span>
                          </div>

                          <div class="plan-side-popup" v-if="
                            showSidePopup[sIndex] &&
                            showSidePopup[sIndex][0] &&
                            showSidePopup[sIndex][0][visit.__visitIndex]
                          ">
                            <div
                              v-if="hasNextSortedVisit(subjectId, visit)"
                              @click.prevent="openPlanNextVisitModal(subjectId, visit)">
                              {{ $t('navigations.plan next visit') }}
                            </div>
                            <div @click.prevent="openManageVisitPopup(visit)">
                             Change Visit Date
                            </div>
                            <div @click.prevent="openManageVisitPopupNew(visit)">
                            Manage Visit
                          </div>
                           <div @click.prevent="openUnscheduledVisitModal(visit, pIndex)">
                                    Add Unscheduled Visit
                                    </div>
                            <div @click.prevent="openchangeplanneddatePopup(visit)">
                             Change Planned Date
                            </div>
                            <div v-if="visit.visitStatus != 'Completed'" @click.prevent="
                              openChangeStatusmodal(
                                visit.studyId,
                                visit.visitNo,
                                subjectId,
                                visit.visitStatus,
                                visit.__visitIndex,
                                'Visit'
                              )
                              ">
                              {{ $t('navigations.change status') }}
                            </div>
                          </div>

                          <ul>
                            <li v-if="observationValue[visit.visitNo + subjectId] === true">
                              <input type="checkbox" />
                              <label @click.prevent="
                                toggleObservationFolder(
                                  visit.siteCode,
                                  visit.patientNo,
                                  visit.visitName,
                                  visit.visitNo,
                                  subjectId
                                )
                                " class="tree_label">
                                {{ $t("navigations.observations") }}
                              </label>

                              <template v-if="categoryFlags[visit.visitNo + subjectId]">
                                <div v-for="docType in categoryFlags[visit.visitNo + subjectId]" :key="docType.id"
                                  class="tree-node mb-2">
                                  <div @click.prevent="docType.flag = !docType.flag">
                                    <span class="cursor-pointer">
                                      <i class="fa fa-file-code-o text-primary me-2"></i>
                                      {{ docType.category }}
                                    </span>
                                  </div>

                                  <div class="row" v-if="docType.flag === true">
                                    <div class="d-flex pt-2 pl-4 cursor-pointer" v-for="(value, index) in docType.code"
                                      :key="index" @click.prevent="
                                        selectDocument(
                                          visit.siteCode,
                                          subjectId,
                                          docType.document[index],
                                          visit.visitName,
                                          subjectId,
                                          visit.siteId
                                        )
                                        ">
                                      <span class="mr-1">{{ value }}</span>
                                      <span v-if="docType.effectiveDateTime[index]">
                                        ({{ filterTimeFormat(docType.effectiveDateTime[index]) }})
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </template>
                            </li>
                          </ul>

                          <template
                            v-if="(activityobject?.[`${visit.visitNo}_${subjectId}`]?.[visit.__visitIndex] || []).length">
                            <ul>
                              <li v-for="(singleactivity, activityindex) in
                                (activityobject?.[`${visit.visitNo}_${subjectId}`]?.[visit.__visitIndex] || [])"
                                :key="singleactivity.activityId">
                                <input v-if="singleactivity.activityId"
                                  :id="activityInputId(singleactivity, subjectId, visit)" type="checkbox" @change="
                                    getFormsByVisit(
                                      subjectId,
                                      visit.visitNo,
                                      visit.visitName,
                                      visit.__visitIndex,
                                      visit.sheduleId,
                                      activityindex,
                                      singleactivity.activityId,
                                      singleactivity.activityOrder
                                    )
                                    " />

                                  <label class="tree_label" :for="activityInputId(singleactivity, subjectId, visit)"
                                    @click.stop>
                                    <div>
                                      <span>
                                        {{ singleactivity.activityName }}
                                        <span class="badge custom-form-tooltip-wrapper"
                                          :style="`background-color: ${singleactivity.statusHex}; color: black;`">
                                          {{ singleactivity.status }}
                                        </span>
                                      </span>
                                      <button v-if="singleactivity.formStatus !== 'Completed'"
                                        :popovertarget="popoverId(singleactivity.activityId, sIndex, 0, visit.__visitIndex)"
                                        :anchor="popoverId('visitForms', sIndex, 0, visit.__visitIndex)"
                                        class="visit-ellipsis-btn py-0 px-3" @click.stop>
                                        <i class="fa fa-ellipsis-v"></i>
                                      </button>
                                      <div :id="popoverId(singleactivity.activityId, sIndex, 0, visit.__visitIndex)" popover
                                        class="visit-popup-menu">
                                        <button @click.prevent.stop="
                                          openChangeStatusmodalforactivity(
                                            singleactivity.actScheduleId,
                                            singleactivity.status,
                                            subjectId,
                                            visit.visitNo,
                                            visit.visitName,
                                            visit.__visitIndex,
                                            visit.sheduleId,
                                            popoverId(singleactivity.activityId, sIndex, 0, visit.__visitIndex),
                                          )
                                          " class="popup-menu-block text-left w-100">
                                          {{ $t('navigations.change status') }}
                                        </button>
                                        <button @click.prevent="
                                          openModal(
                                            {
                                              visitNo: visit.visitNo,
                                              visitName: visit.visitName,
                                              sheduleId: visit.sheduleId,
                                              studyId: visit.studyId,
                                              visitId: singleactivity.visitId,
                                              actScheduleId: singleactivity.actScheduleId,
                                              subjectId: singleactivity.subjectId,
                                              activityId: singleactivity.activityId,
                                              activityName: singleactivity.activityName
                                            },
                                            subjectname,
                                            visit.siteCode,
                                            singleactivity.status,
                                            popoverId(singleactivity.activityId, sIndex, 0, visit.__visitIndex)
                                          )
                                          " class="popup-menu-block text-left w-100">
                                          {{ $t('navigations.new form') }}
                                        </button>
                                      </div>
                                    </div>
                                  </label>

                                <template v-if="visitFormObj[visit.visitNo + subjectId]">
                                  <ul>
                                    <li v-for="singlevisit in visitFormObj[
                                      visit.visitNo + subjectId
                                    ][activityindex]" :key="singlevisit.sheduleId">
                                      <input v-if="singlevisit.templateName" type="checkbox"
                                        :id="formInputId(singlevisit, 0, visit.__visitIndex, activityindex)"
                                        @click.prevent="
                                          gotoform(singlevisit)
                                        " />

                                      <label class="tree_label"
                                        :for="formInputId(singlevisit, 0, visit.__visitIndex, activityindex)"
                                        @click.stop>
                                        <div class="d-flex">
                                          <div class="d-flex align-items-center">
                                            <p class="mb-0" style="max-width: 28ch;">
                                              {{
                                                // singlevisit.formStatus === 'Completed'
                                                //   ? singlevisit.templateName +
                                                //     ' - ' +
                                                //     (singlevisit.visitCompletedDate
                                                //       ? filter(singlevisit.visitCompletedDate) + '-'
                                                //       : '')
                                                //   : singlevisit.templateName
                                                  singlevisit.formStatus === 'Completed'
                                                  ? singlevisit.templateName + ' (' + singlevisit.version + ') - ' + singlevisit.languageCode?.toUpperCase() +
                                                  ' - ' +
                                                  (singlevisit.visitCompletedDate
                                                  ? filter(singlevisit.visitCompletedDate) + '-'
                                                  : '')
                                                  : singlevisit.templateName + ' (' + singlevisit.version + ') - ' + singlevisit.languageCode?.toUpperCase()
                                              }}
                                            </p>

                                            <span class="badge custom-tooltip-wrapper"
                                              @mouseenter="showPopover(`formStatus-${singlevisit.sheduleId}-0-${visit.__visitIndex}`)"
                                              @mouseleave="hidePopover(`formStatus-${singlevisit.sheduleId}-0-${visit.__visitIndex}`)"
                                              :popovertarget="`formStatus-${singlevisit.sheduleId}-0-${visit.__visitIndex}`"
                                              :style="`background-color: ${singlevisit.formStatusHex}; color: black;`">
                                              {{ singlevisit.formStatus }}
                                            </span>

                                            <span v-if="singlevisit.formStatusDescription" popover
                                              class="custom-form-tooltip-text"
                                              :id="`formStatus-${singlevisit.sheduleId}-0-${visit.__visitIndex}`">
                                              {{ singlevisit.formStatusDescription }}
                                            </span>
                                          </div>

                                          <button
                                            :popovertarget="popoverId(singlevisit.sheduleId, sIndex, 0, visit.__visitIndex)"
                                            :anchor="popoverId('visitForms', sIndex, 0, visit.__visitIndex)"
                                            class="visit-ellipsis-btn py-0 px-3" @click.stop>
                                            <i class="fa fa-ellipsis-v"></i>
                                          </button>

                                          <div :id="popoverId(singlevisit.sheduleId, sIndex, 0, visit.__visitIndex)" popover
                                            class="visit-popup-menu">
                                            <button v-if="singlevisit.formStatus !== 'Completed'" @click.prevent.stop="
                                              openChangeStatusmodal(
                                                visit.studyId,
                                                visit.visitNo,
                                                subjectId,
                                                visit.visitStatus,
                                                visit.__visitIndex,
                                                'Form',
                                                popoverId(singlevisit.sheduleId, sIndex, 0, visit.__visitIndex),
                                                visit.visitName,
                                                singlevisit.formStatus,
                                                singlevisit.formId,
                                                singlevisit.sheduleId
                                              )
                                              " class="popup-menu-block text-left w-100">
                                              {{ $t('navigations.change status') }}
                                            </button>
                                          </div>
                                        </div>
                                      </label>
                                    </li>
                                  </ul>
                                </template>
                              </li>
                            </ul>
                          </template>
                        </template>
                      </li>
                    </ul>
                    </li>
                  </template>
                </ul>
              </li>
            </ul>
          </div>
  </div>
     

  <!-- modal starts -->
  <div class="modal-wrapper">
    <div class="modal-container">
      <div class="titleclass">
        <h4 class="px-3 mt-1">{{ $t("navigations.add form") }}</h4>
        <div class="closebutton mt-1">
          <a style="color: white" class="close-link">
            <i class="fa fa-times" @click.prevent="closeModal"></i>
          </a>
        </div>
      </div>
      <div class="modelbody p-0">
        <div class="mb-3 p-2">
          <div class="form-group">
            <div class="d-flex flex-column flex-lg-row">
              <div class="col-lg-12 my-2">
                <select class="form-control" placeholder="Search by Status" v-model="selectedTemplate">
                  <option value="" disabled>
                    {{ $t("navigations.select forms") }}
                  </option>
                  <option v-for="templates in templateList" :key="templates.templateId" :value="templates.templateId">
                    {{ templates.templateName }} ( {{ templates.version }} )
                  </option>
                </select>
              </div>
            </div>

            <div class="d-flex justify-content-center my-3">
              <button class="save_btn py-1 px-4" @click.prevent="
                gotofillform(
                  selectedVisit.visit,
                  selectedVisit.subjectId,
                  selectedVisit.siteCode
                )
                ">
                {{ $t("navigations.fill form") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- activate next visit -->
   <teleport to="#wrapper">
  <customModal v-if="plannextvisitPopup == true" :containersm="true" @closeModal="closeplannextvisitModal()">
    <template #title>
      Plan Next Visit
    </template>
    <template #body>
      <div class="container mt-3">
        <div class="row">

          <!-- Visit Name -->
          <div class="col-md-6 mb-3">
            <label class="form-label mb-0">Visit Name</label>
            <select
              class="form-select no-arrow"
              v-model="createvisitobj.visitName"
              disabled
              @change="changeVisitDate"
            >
              <option selected value="">All</option>
              <option
                v-for="schedule in visitobj[createvisitobj.patientId][0]"
                :key="schedule.sheduleId"
                :value="schedule.visitName"
              >
                {{ schedule.visitName }}
              </option>
            </select>
          </div>

          <!-- Planned Visit Date -->
          <div class="col-md-6 mb-3">
            <label class="form-label mb-0">Planned Visit Date</label>
            <flat-pickr
              v-model="oldvisitdatetDate"
              :config="dateTimePickerConfig"
              :disabled="true"
              class="fp-datetime-input"
            />
          </div>

          <!-- New Visit Date -->
          <div class="col-md-6 mb-3">
            <label class="form-label mb-0">
              New Visit Date
              <sup><i class="fa fa-asterisk required"></i></sup>
            </label>
            <flat-pickr
              v-model="newvisitDate"
              :config="dateTimePickerConfig"
              class="fp-datetime-input"
            />
          </div>

        </div>

        <div class="mt-3">
          <h6 class="border-bottom pb-0 mb-3" style="font-size:13px; font-weight:600;">
            Visit Window
          </h6>

          <div class="row">
            <!-- Pre Visit Date -->
            <div class="col-md-6 mb-3">
              <label class="form-label mb-0">Pre-Visit Date</label>
              <flat-pickr
                v-model="preVisitDate"
                :config="dateTimePickerConfig"
                class="fp-datetime-input"
              />
            </div>

            <!-- Post Visit Date -->
            <div class="col-md-6 mb-3">
              <label class="form-label mb-0">Post-Visit Date</label>
              <flat-pickr
                v-model="postVisitDate"
                :config="dateTimePickerConfig"
                class="fp-datetime-input"
              />
            </div>
          </div>
        </div>

        <div class="text-end mb-2">
          <button
            type="button"
            @click.prevent="Createnewvisitfun(createvisitobj)"
            class="save_btn py-1 px-4"
            :disabled="showLoader"
          >
            <span v-if="showLoader == false">Save</span>
            <span v-else>
              <i class="fa fa-spinner fa-spin"></i>
            </span>
          </button>
        </div>

      </div>
    </template>

  </customModal>
  </teleport>
  <!-- manage visit popup -->
   <teleport to="#wrapper">
  <customModal v-if="ManageVisitPopup == true" :containersm="true" @closeModal="closeManageVisitModal()">
    <template #title>
      Change Visit Date
    </template>
    <template #body>
      <div class="container mt-3">
        <p>Updating these fields will change the actual visit start and end dates. Please confirm the information is accurate before saving.</p>
        <div class="row justify-content-center">
          <div class="p-2">

            <!-- Visit Start Date -->
            <div class="col-md-12 d-flex align-items-center">
              <label class="form-label col-md-6 mb-0">Visit Start Date<sup><i
                    class="fa fa-asterisk required"></i></sup></label>
              <div class="col-md-6 px-0">
                <flat-pickr v-model="actualVisitStartDate" :config="dateTimePickerConfig" class="fp-datetime-input w-100 visit-datetime-input" />
              </div>
            </div>

            <!-- Visit End Date -->
            <div class="col-md-12 d-flex align-items-center mt-2">
              <label class="form-label col-md-6 mb-0">Visit End Date</label>
              <div class="col-md-6 px-0">
                <flat-pickr v-model="actualVisitEndDate" :config="dateTimePickerConfig" class="fp-datetime-input w-100 visit-datetime-input" />
              </div>
            </div>

            <!-- Completed Checkbox -->
            <div class="col-md-12 text-start">
              <div class="form-check mt-4">
                <input class="form-check-input" type="checkbox" id="completedCheck" v-model="isCompleted" />
                <label class="form-check-label" for="completedCheck">
                  Mark this visit as completed
                </label>
              </div>
            </div>
            <div class="row">
              <div class="col text-end">
                <button type="button" @click.prevent="updateactualvisitdates(managevisitobj)"
                  class="save_btn py-1 px-4" :disabled="showCreateLoader">
                  <span v-if="showCreateLoader == false">Save</span>
                  <span v-else><i class="fa fa-spinner fa-spin"></i></span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>    
  </customModal>
  </teleport>
  
  <!-- planned visit popup -->
   <teleport to="#wrapper">
   <changeplanneddatePopup v-if="plannedvisitpopup" @cycleScheduled="onCycleScheduled" :visitobj="plannedvisitobject" @closeModal="plannedvisitpopup = false"></changeplanneddatePopup>
   </teleport>
  <!-- Change schedule status  -->
   <teleport to="#wrapper">
  <ChangeSchedulestatus v-if="showChangeSchedule" :statusType="statusType" :changeStatus="changeStatus"
    :selectedScheduleId="scheduleId" :selectedFormId="selectedForm" @changeStatus="changedStatus()"
    @closeModal="closeChangeScheduleModal()" />
  </teleport>
  <!-- Change activity status  -->
   <teleport to="#wrapper">
  <ChangeactivityStatusPopup v-if="showChangeActivity" :activitystatusreload="activitystatusreload"
    :currentstatus="currentactivitystatus" :activityid="selectedActivityid" @changeStatus="changedactivityStatus"
    @closeModal="closeChangeactivityModal()" />
  <CreateScheduleCyclePopUp v-if="CreateScheduleCyclePopUp" @closeModal="CreateScheduleCyclePopUp = false"
    @cycleScheduled="onCycleScheduled" :patientid="selectedPatientId" :cycleid="selectedCycleId" />
  <ManageCyclePopup v-if="ManageScheduleCyclePopUp" @closeModal="ManageScheduleCyclePopUp = false"
    @cycleScheduled="onCycleScheduled" :occurence="selectedOccurrence" :patientid="selectedPatientId"
    :cycleid="selectedCycleId" />
  <ChangeCycleStatusPopUp v-if="ChangeCycleStatusPopUp" @closeModal="ChangeCycleStatusPopUp = false"
    :patientid="selectedPatientId" :cycleid="selectedCycleId" :occurrence="selectedOccurrence" />
  <mapformmodel v-if="showformmodelpopup" :formid=currentformid :scheduleId="selectedScheduleId"
    :subjectidpassed="this.subjectId" @closeformModal="showformmodelpopup = false" @formMapped="onFormMapped" />
 </teleport>
 <teleport to="#wrapper">
 <!-- Manage visit popup start -->
  <ManageVisit v-if="showManageVisitModal" :managevisitobj="managevisitobj" @saveVisit="refreshVisits" @closeModal="closeManageVisitModalNew" />
 </teleport>
 <teleport to="#wrapper">
  <!-- Manage visit popup end -->
  <!-- unscheduled visit  modal start -->
  <UnscheduledVisitModal v-if="showUnscheduledVisitModal" @refreshVisits="refreshVisits" :patientId="patientId"
    @closeModal="closeUnscheduledVisitModal" />
  </teleport>
  <!-- unscheduled visit  modal end -->

</template>
<script src="./SubjectSchedule.js"></script>
<style scoped>
@import "../../assets/css/style.css";
@import "../../assets/bootstrap.css";
@import "../../assets/font-awesome/css/font-awesome.css";
@import "../../components/subject_tree/tree.css";

/* Tooltip box */
.custom-tooltip-text,
.custom-form-tooltip-text {
  position: absolute;
  inset: auto;
  margin: 0;
  bottom: anchor(top);
  right: anchor(right);
  background-color: #616161;
  color: white;
  padding: 6px 10px;
  font-size: 0.75rem;
  border-radius: 4px;
  border: none;
  max-width: 180px;
  white-space: normal;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  margin-block-end: 4px;

}
.fixedheight{
  min-height: 150px;
}
.custom-tooltip-text:popover-open {
  display: grid;
}

.visit-ellipsis-btn {
  anchor-name: --manage-btn;
  border: 0;
}

.visit-popup-menu {
  position: absolute;
  inset: auto;
  text-align: left;
  border-radius: 5px;
  border: 1px solid #e7eaec;
  background-color: rgba(255, 255, 255, 1);
  box-shadow: 3px 3px 3px rgba(160, 160, 160, 0.5);
  z-index: 200;
}

.visit-popup-menu {
  top: anchor(bottom);
  right: anchor(left);
  width: fit-content;
  margin-inline-end: 5px;
}

.visit-popup-menu {
  position-try-fallbacks: --bottom;
  top: anchor(bottom);
  right: anchor(right);
  width: 160px;
}

.visit-popup-menu>button {
  border: 0;
  font-size: 0.8rem;
  font-weight: 400;
  color: rgba(0, 0, 0);
  padding: 0.6rem 0.8rem;
}

[popover]:popover-open {
  display: flex;
  flex-direction: column;
  align-items: baseline;
  animation: fadeIn 0.2s ease-in-out;
}

.visit-popup-menu>.popup-menu-block:hover,
.popup-submenu>div:hover {
  background-color: #e4eaf9;
}

@position-try --bottom {
  inset: auto;
  bottom: anchor(top);
  right: anchor(left);
}

/* CSS Popover Styles */
.linkstyle {
  cursor: pointer;
}

.plan-side-popup {
  position: absolute;
  text-align: left;
  right: 18px;
  top: 6px;
  border-radius: 5px;
  border: 1px solid #e7eaec;
  background-color: rgba(255, 255, 255, 1);
  width: min(124px, 90%);
  box-shadow: 3px 3px 3px rgba(160, 160, 160, 0.5);
  z-index: 200;
}

.float-right .tool-tip {
  visibility: hidden;
  width: max-content;
  background-color: #616161;
  color: #fff;
  text-align: center;
  border-radius: 0.3em;
  padding: 0.1rem 0.8rem;
  right: 15px;
  top: -15px;
  font-size: 0.8rem;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  -webkit-transition: visibility 75ms ease-in;
  transition: visibility 75ms ease-in;
}

.plan-side-popup>div {
  cursor: pointer;
  padding: 0.5rem;
}

.plan-side-popup>div:hover {
  background-color: #e4eaf9;
}

.modal-container {
  background: #fff;
  width: min(50%, 90%);
  border-radius: 4px;
  position: fixed;
  transition: all 0.3s ease-in-out;
  height: auto !important;
  margin-top: 200px;
}

.modal-wrapper-changetemplate {
  position: fixed;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.5);
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 1;
  pointer-events: auto;
  overflow: hidden;
  z-index: 9999;
}

.modelbody {
  overflow: unset !important;
}

.modelbody {
  background: #fff;
  /* background-color: aquamarine;  */
  margin: 0;
  padding: 5%;
}

.plan-side-popup {
  position: absolute;
  text-align: left;
  right: 17px;
  top: 12px;
  border-radius: 5px;
  border: 1px solid #e7eaec;
  background-color: rgba(255, 255, 255, 1);
  width: min(90px, 90%);
  box-shadow: 3px 3px 3px rgba(160, 160, 160, 0.5);
  z-index: 200;
}

.modal__schedule__container-forms {
  background: #fff;
  width: min(30%, 90%);
  border-radius: 4px;
  position: fixed;
  overflow-x: hidden;
  pointer-events: auto;
}

.modal__schedule__wrapper {
  position: fixed;
  inset: 0;
  background: rgb(0 0 0 / 18%);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  z-index: 3000;
}

.badge-genre {
  background-color: #b6bdbf;
  color: #ffffff;
}

.badge-grn {
  background-color: #1ab394;
  color: #ffffff;
}

.modal__schedule__title {
  background-color: var(--pop-up-background);
  color: #ffffff;
}

.overflow-block-form {
  width: 100%;
  padding: 8px 8px;
  overflow-x: scroll;
}

.horizondalscroll {
  overflow-y: auto;
  max-height: 500px;
}

.minheight {
  min-height: 438px;
}

.no-arrow.form-select {
  background-image: none !important;
  padding-right: 0.75rem;
}

.right-tabs {
  display: flex;
  flex-wrap: nowrap;
  gap: 6px;
  overflow-x: auto;
  align-items: center;
}

.right-tab {
  border: 1px solid #e7eaec;
  background: #f5f5f6;
  color: #676a6c;
  font-weight: 600;
  padding: 6px 10px;
  border-radius: 3px 3px 0 0;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  width: auto !important;
  flex: 0 0 auto;
}

.right-tab.active {
  background: #ffffff;
  color: #1c2b36;
  border-bottom-color: #ffffff;
  position: relative;
}

:deep(.fp-datetime-input.flatpickr-input),
:deep(.fp-datetime-input.flatpickr-input:focus),
:deep(.fp-datetime-input.flatpickr-input.active) {
  background-color: #ffffff;
  background-image: none;
  border: 1px solid #e5e6e7;
  border-radius: 1px;
  color: inherit;
  display: block;
  width: 100%;
  min-height: 30px;
  padding: 4px 12px;
  font-size: 13px;
  line-height: 1.42857143;
  box-sizing: border-box;
  box-shadow: none;
  outline: none;
  transition: none;
}

:deep(.fp-datetime-input.flatpickr-input:focus),
:deep(.fp-datetime-input.flatpickr-input.active) {
  border-color: #145faf;
}

:deep(input.fp-datetime-input.flatpickr-input.active) {
  position: static !important;
  opacity: 1 !important;
  pointer-events: auto !important;
  display: block !important;
}

:deep(.fp-datetime-input.flatpickr-input:disabled) {
  background-color: #e9ecef;
  cursor: not-allowed;
}

</style>
